export default __webpack_public_path__ + "static/media/partner.319e7787.jpg";